module.exports = __webpack_public_path__ + "img/project6.f44d4815.jpg";